import { axiosInstance } from "./axiosInstance";

const getNetwork = (params, signal) => {
  return axiosInstance.get('network', {
    params,
    signal
  });
}

const getConnections = (params, signal) => {
  return axiosInstance.get('connections', { params, signal });
}

const getNetworkConnections = (params, signal) => {
  return axiosInstance.get('connections/list', { params, signal });
}

const getOtherConnections = (params, signal) => {
  return axiosInstance.get('connections/list-connected', { params, signal });
}


const deleteConnection = ({ id, userType, connectedUserType }) => {
  return axiosInstance.delete(`connections/${id}?account_type=${userType}&connected_user_type=${connectedUserType}`);
}


const connectUser = (data) => {
  return axiosInstance.post('connections/connect', data);
}

const getTrustedConnections = () => {
  return axiosInstance.get('connections/trusted-connections');
}

export {
  getNetwork,
  getConnections,
  getNetworkConnections,
  getOtherConnections,
  connectUser,
  deleteConnection,
  getTrustedConnections
}